import React from "react"
import { graphql } from "gatsby"
import Layout from "gatsby-theme-blank/src/components/Layout/layout"
import SEO from "gatsby-theme-blank/src/components/seo"
import NonStretchedImage from "gatsby-theme-blank/src/components/Image/non-stretched-image"
import AdditionalInformation from "gatsby-theme-blank/src/components/additional-information"
import {
  pageAdditionalInfos,
  pageBase,
  gridAriane,
  gridContent,
  gridResume,
  gridTags,
  gridTitle,
  pageTitle,
  pageImg,
  pageContentFooter,
  pageContentFooterBack,
} from "./styles/detailsPage.module.scss"
import PropTypes from "prop-types"
import {
  AdditionalInfos,
  PageFooterContainer,
  PageTaxo,
  PageTitle,
} from "./styled-components/page-styled"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import Ariane from "gatsby-theme-blank/src/components/Ariane/ariane"
import SocialPanel from "gatsby-theme-blank/src/components/SocialMedias/social-panel"
import { ContentSplitter } from "gatsby-theme-blank/src/components/ContentSplitter/content-splitter"
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodePage(path: { alias: { eq: $slug } }) {
      ...PageItem
    }
  }
`
//-----------------------QueryGraphql---------------------------//

//-----------------------Parent component---------------------------//

const PageTemplate = ({ data, location }) => {
  const nodePage = data.nodePage
  return (
    <Layout isDetail={true}>
      <SEO
        title={nodePage.title}
        description={
          "Dans cette page, vous découvrez le contenu suivant : " +
          nodePage.title
        }
        nodeImageUrl={
          nodePage.relationships?.field_image_page_de_base?.localFile
            ?.SlugifiedPublicUrl
        }
      />
      <div className={pageBase}>
        <PageImg nodePage={nodePage} />
        <div className={gridAriane}>
          <Ariane isDetail={true} postName={nodePage.title} />
        </div>
        <div className={gridTitle}>
          <PageTitle className={pageTitle}>{nodePage.title}</PageTitle>
        </div>
        <PageTags nodePage={nodePage} />
        <PageContent nodePage={nodePage} />
      </div>
      <PageContentFooter nodePage={nodePage} location={location.href} />
      <PageInfos nodePage={nodePage} />{" "}
    </Layout>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component/Content---------------------------//

const PageContent = ({ nodePage }) => {
  return (
    <>
      <ContentSplitter
        node={nodePage}
        resumeClassName={gridResume}
        contentClassName={gridContent}
        splitPoint={625}
      />
    </>
  )
}

//-----------------------Child component/Content---------------------------//

//-----------------------Child component/Tags---------------------------//

const PageTags = ({ nodePage }) => {
  return (
    <>
      {nodePage.relationships.field_taxonomie_thematique && (
        <div className={gridTags}>
          <p>Thématique</p>
          {nodePage.relationships.field_taxonomie_thematique.map(
            (taxo, index) => {
              if (
                index ===
                nodePage.relationships.field_taxonomie_thematique.length - 1
              ) {
                return (
                  <PageTaxo key={taxo.name}>
                    <TransitionFade link={taxo.path.alias}>
                      {taxo.name}
                    </TransitionFade>
                  </PageTaxo>
                )
              }
              return (
                <PageTaxo key={taxo.name}>
                  <TransitionFade link={taxo.path.alias}>
                    {taxo.name},&nbsp;
                  </TransitionFade>
                </PageTaxo>
              )
            }
          )}
        </div>
      )}
    </>
  )
}

//-----------------------Child component/Tags---------------------------//

//-----------------------Child component/Img---------------------------//

const PageImg = ({ nodePage }) => {
  const themeColors = useBuildData().theme_settings.palette
  const options = {
    buttons: {
      backgroundColor: themeColors.b_color_gradients.b_dark,
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: true,
      showNextButton: false,
      showPrevButton: false,
      showThumbnailsButton: false,
    },
  }
  return (
    <div className={pageImg}>
      <SimpleReactLightbox>
        <SRLWrapper options={options}>
          {nodePage.relationships?.field_image_page_de_base?.localFile && (
            <NonStretchedImage
              alt={nodePage.field_image_page_de_base.alt}
              {...nodePage.relationships.field_image_page_de_base.localFile}
              ariaHidden={true}
            />
          )}
        </SRLWrapper>
      </SimpleReactLightbox>
    </div>
  )
}

//-----------------------Child component/Img---------------------------//

//-----------------------Child component/ContentFooter---------------------------//

const PageContentFooter = ({ nodePage, location }) => (
  <>
    <PageFooterContainer className={pageContentFooter}>
      <div className={pageContentFooterBack}>
        <TransitionFade arialabel="Retour à l'accueil" link="/">
          Retour à l&apos;accueil
        </TransitionFade>
      </div>
      <div>
        <SocialPanel location={location} postData={nodePage} />
      </div>
    </PageFooterContainer>
  </>
)

//-----------------------Child component/ContentFooter---------------------------//

//-----------------------Child component/Infos---------------------------//

const PageInfos = ({ nodePage }) => (
  <>
    {nodePage.field_infos_complementaires && (
      <AdditionalInfos className={pageAdditionalInfos}>
        <AdditionalInformation node={nodePage} />
      </AdditionalInfos>
    )}
  </>
)

//-----------------------Child component/Infos---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Prop-Types---------------------------//

PageTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object,
}
PageInfos.propTypes = {
  nodePage: PropTypes.object.isRequired,
}
PageContentFooter.propTypes = {
  nodePage: PropTypes.object.isRequired,
  location: PropTypes.object,
}
PageTags.propTypes = {
  nodePage: PropTypes.object.isRequired,
}
PageImg.propTypes = {
  nodePage: PropTypes.object.isRequired,
}
PageContent.propTypes = {
  nodePage: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default PageTemplate
